var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDataCollect(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 128,
    viewBox: "0 0 136 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_94_1973)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_94_1973",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.1006,
    y: 53.3003,
    width: 22.4,
    height: 15.4,
    rx: 0.7
  })), /*#__PURE__*/React.createElement("rect", {
    x: 56.1006,
    y: 53.3003,
    width: 22.4,
    height: 15.4,
    rx: 0.7,
    stroke: "#5D38E5",
    strokeWidth: 5.6,
    strokeLinejoin: "round",
    mask: "url(#path-1-inside-1_94_1973)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_94_1973",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.1006,
    y: 68.0005,
    width: 17.5,
    height: 10.5,
    rx: 0.7
  })), /*#__PURE__*/React.createElement("rect", {
    x: 35.1006,
    y: 68.0005,
    width: 17.5,
    height: 10.5,
    rx: 0.7,
    stroke: "#5D38E5",
    strokeWidth: 5.6,
    strokeLinejoin: "round",
    mask: "url(#path-2-inside-2_94_1973)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3_94_1973",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.4004,
    y: 68.0005,
    width: 17.5,
    height: 10.5,
    rx: 0.7
  })), /*#__PURE__*/React.createElement("rect", {
    x: 83.4004,
    y: 68.0005,
    width: 17.5,
    height: 10.5,
    rx: 0.7,
    stroke: "#5D38E5",
    strokeWidth: 5.6,
    strokeLinejoin: "round",
    mask: "url(#path-3-inside-3_94_1973)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-4_94_1973",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.1006,
    y: 42.1001,
    width: 17.5,
    height: 10.5,
    rx: 0.7
  })), /*#__PURE__*/React.createElement("rect", {
    x: 35.1006,
    y: 42.1001,
    width: 17.5,
    height: 10.5,
    rx: 0.7,
    stroke: "#5D38E5",
    strokeWidth: 5.6,
    strokeLinejoin: "round",
    mask: "url(#path-4-inside-4_94_1973)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-5_94_1973",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.4004,
    y: 42.1001,
    width: 17.5,
    height: 10.5,
    rx: 0.7
  })), /*#__PURE__*/React.createElement("rect", {
    x: 83.4004,
    y: 42.1001,
    width: 17.5,
    height: 10.5,
    rx: 0.7,
    stroke: "#5D38E5",
    strokeWidth: 5.6,
    strokeLinejoin: "round",
    mask: "url(#path-5-inside-5_94_1973)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-6_94_1973",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.2002,
    y: 32.3003,
    width: 17.5,
    height: 10.5,
    rx: 0.7
  })), /*#__PURE__*/React.createElement("rect", {
    x: 58.2002,
    y: 32.3003,
    width: 17.5,
    height: 10.5,
    rx: 0.7,
    stroke: "#5D38E5",
    strokeWidth: 5.6,
    strokeLinejoin: "round",
    mask: "url(#path-6-inside-6_94_1973)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-7_94_1973",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.2002,
    y: 79.2002,
    width: 17.5,
    height: 10.5,
    rx: 0.7
  })), /*#__PURE__*/React.createElement("rect", {
    x: 58.2002,
    y: 79.2002,
    width: 17.5,
    height: 10.5,
    rx: 0.7,
    stroke: "#5D38E5",
    strokeWidth: 5.6,
    strokeLinejoin: "round",
    mask: "url(#path-7-inside-7_94_1973)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3008 53.3003V42.8003",
    stroke: "#5D38E5",
    strokeWidth: 2.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3008 79.2002V68.7002",
    stroke: "#5D38E5",
    strokeWidth: 2.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2002 47.7002C52.9341 47.7002 54.668 47.7002 56.8001 47.7002C57.1867 47.7002 57.5002 48.0136 57.5002 48.4002V72.9002C57.5002 73.2868 57.1868 73.6002 56.8002 73.6002H51.2002",
    stroke: "#5D38E5",
    strokeWidth: 2.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4004 47.7002C81.6665 47.7002 79.9326 47.7002 77.8005 47.7002C77.4139 47.7002 77.1004 48.0136 77.1004 48.4002V72.9002C77.1004 73.2868 77.4138 73.6002 77.8004 73.6002H83.4004",
    stroke: "#5D38E5",
    strokeWidth: 2.8,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_94_1973",
    x: 0.100586,
    y: 0.100293,
    width: 135.8,
    height: 127.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.364706 0 0 0 0 0.219608 0 0 0 0 0.898039 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_94_1973"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_94_1973",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDataCollect);
export default __webpack_public_path__ + "static/media/icon_data_collect.8da8382fe71b26950e3eb534a2e700a9.svg";
export { ForwardRef as ReactComponent };